import { Currency } from '@/core/currency/interfaces';

const GHS: Currency = {
    name: 'Ghanaian Cedi',
    demonym: 'Ghanaian',
    majorSingle: 'Cedi',
    majorPlural: 'Cedis',
    codeNumeric: '936',
    symbol: 'GH₵',
    symbolNative: '₵',
    minorSingle: 'Pesewa',
    minorPlural: 'Pesewas',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'GHS',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default GHS;
